import React, { useCallback, useEffect, useState } from "react";
import {
  Backdrop,
  Box,
  Divider,
  Fade,
  Grid,
  Modal,
  TextField,
  Typography,
  Button,
} from "@mui/material";
import { Form, Formik } from "formik";
import { useAPI } from "app/hooks/useApi";
import Swal from "sweetalert2";

const ModalRegisterPetition = ({
  open,
  handleClose,
  processId,
  getProcess,
}) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: 4,
  };

  const initialValues = {
    processo_rpi_id: processId || "",
    numero_protocolo: "",
    data: "",
    imagem: "",
    servico: "",
    cliente: "",
    delivery: "",
    data_delivery: "",
    pagamento: null,
    agencia_banco: "",
    data_pagamento: "",
    valor_pagamento: "",
  };

  const [peticao, setPeticao] = useState(initialValues);

  const { makeRequest } = useAPI();

  const handleSubmit = useCallback(
    async (values) => {
      try {
        const { agencia_banco, data_pagamento, valor_pagamento } = values;

        if (agencia_banco || data_pagamento || valor_pagamento) {
          values.pagamento = {
            agencia_nome_banco: agencia_banco,
            data: data_pagamento,
            valor: valor_pagamento,
          };
        }

        values.processo_rpi_id = Number(processId);

        delete values.agencia_banco;
        delete values.data_pagamento;
        delete values.valor_pagamento;
        const response = await makeRequest(
          "/peticoes-processos-rpis",
          "POST",
          values
        );

        if (response.status === 201) {
          Swal.fire("Cadastro concluído", "Petição registrada", "success");
          getProcess();
        }
      } catch (error) {

        Swal.fire("Erro ao cadastrar a petição", error.message, "error");
      }
    },
    [peticao]
  );

  useEffect(() => {
    return () => {
      setPeticao(initialValues);
    };
  }, []);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Typography id="transition-modal-title" variant="h6" component="h2">
            Cadastro de petição
          </Typography>
          <Divider sx={{ my: 1 }} />
          <Formik
            initialValues={peticao}
            enableReinitialize
            validateOnBlur={true}
            onSubmit={handleSubmit}
          >
            {({
              values,
              setFieldValue,
              errors,
              handleBlur,
              handleChange,
              setFieldTouched,
              touched,
            }) => (
              <Form>
                <Grid container spacing={2} p={2}>
                  <Grid item xs={6}>
                    <TextField
                      label="Número do protocolo"
                      name="numero_protocolo"
                      value={values.numero_protocolo}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <TextField
                      label="Data"
                      name="data"
                      type="date"
                      value={values.data}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <TextField
                      label="Imagem"
                      name="imagem"
                      value={values.imagem}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <TextField
                      label="Serviço"
                      name="servico"
                      value={values.servico}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <TextField
                      label="Cliente"
                      name="cliente"
                      value={values.cliente}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <TextField
                      label="Entrega (delivery)"
                      name="delivery"
                      value={values.delivery}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <TextField
                      label="Data Delivery"
                      name="data_delivery"
                      type="date"
                      value={values.data_delivery}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <TextField
                      label="Agência / Banco"
                      name="agencia_banco"
                      value={values.agencia_banco}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <TextField
                      label="Data de pagamento"
                      name="data_pagamento"
                      type="date"
                      value={values.data_pagamento}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <TextField
                      label="Valor pagamento"
                      name="valor_pagamento"
                      type="number"
                      value={values.valor_pagamento}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                    />
                  </Grid>

                  <input
                    type="hidden"
                    name="processo_rpi_id"
                    value={Number(processId)}
                  />

                  <Grid item xs={12} textAlign="right">
                    <Button type="submit" variant="contained" color="success">
                      Salvar
                    </Button>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </Box>
      </Fade>
    </Modal>
  );
};

export default React.memo(ModalRegisterPetition);
